var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useHooks } from '../generators/box-base-props';
import React from 'react';
import { getRowProps } from '../generators/flex-base-props';
import { ScrollBar } from '../ScrollBar';
export var Row = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var forwardRef = React.useRef(null);
    React.useEffect(function () { if (ref) {
        if (typeof ref === "function") {
            ref(forwardRef.current);
        }
        else {
            ref.current = forwardRef.current;
        }
    } });
    useHooks(props);
    if (typeof props.show !== 'undefined')
        props.hidden = !props.show;
    if (props.hidden)
        return null;
    var baseProps = getRowProps(props, forwardRef);
    children = getContent(children, props);
    return _jsx(_Fragment, { children: _jsx("div", __assign({}, baseProps.props, { className: baseProps.classes, style: baseProps.styles, ref: forwardRef }, { children: children })) });
});
function getContent(children, props) {
    if (props.scrollSimple)
        return _jsx(ScrollBar, { children: children });
    else
        return children;
}
;
